import React from "react";
import {InfoWindow} from "react-google-maps";
import JoinPickupSiteFilter from "./JoinPickupSiteFilter.js";
import {PATH_IMAGES, compareArrays} from "../../common/utils";
import {PickupSiteTypes, PickupSiteSelectionTypes, GOOGLE_UNDEFINED_ERROR_MESSAGE} from "../../common/constants";
import {PickupSitesMap} from "../common/PickupSitesMap";
import {translate} from '../../i18n/translate.js';

class JoinPickupSiteMap extends React.Component {
    state = {
        center: this.props.centerLocation,
        markers: [],
        bounds:{},
        zoom: this.props.zoomLevel
    };

    componentWillMount() {
        this.getPickupSites({});
    }

    componentWillReceiveProps(nextProps) {
        if(!compareArrays(nextProps.availablePickupSites, this.props.availablePickupSites)) {
            this.setState({zoom:undefined, center:undefined});
            this.getPickupSites(nextProps);
        }
    }

    createMarker = (pickupSite, icon, type) => {
        let lat;
        let lng;
        if (pickupSite.type === PickupSiteTypes.ZONE ) {
            lat = pickupSite.privateLat;
            lng = pickupSite.privateLng;
        } else {
            lat = pickupSite.lat;
            lng = pickupSite.lng;
        }
        return {
            position: new google.maps.LatLng(lat, lng),
            showInfo: false,
            icon: icon,
            title: pickupSite.title,
            key: pickupSite.key,
            pickupSite: pickupSite,
            type: type
        }
    };

    getPickupSites = (nextProps) => {
        let markers = [];
        let bounds;
        try {
            bounds = new google.maps.LatLngBounds();
        }
        catch(error) {
            this.props.errorFetching(GOOGLE_UNDEFINED_ERROR_MESSAGE);
            return;
        }
        const availablePickupSites = (nextProps.availablePickupSites || this.props.availablePickupSites || []);
        const waitListIcon = PATH_IMAGES + "site-waitlist-large.png";
        const availableIcon = PATH_IMAGES + "site-large.png";
        const siteNotSelectable = PATH_IMAGES + "site-not-selectable-large.png";

        for (let i = 0; i < availablePickupSites.length; i++) {
            let pickupSite = availablePickupSites[i];
            let marker;
            if (pickupSite.isAvailable) {
                marker = this.createMarker(pickupSite, pickupSite.isNonSelectable ? siteNotSelectable : availableIcon, pickupSite.isNonSelectable ? 'notSelectable' : 'available');
            } else if (!pickupSite.isAvailable && pickupSite.isWaitListAllowed) {
                marker = this.createMarker(pickupSite, pickupSite.isNonSelectable?siteNotSelectable:waitListIcon, pickupSite.isNonSelectable?'notSelectable':'waitList');
            }
            if(marker) {
                bounds.extend(marker.position);
                markers.push(marker);
            }
        }
        if(this.map) {
            this.map.fitBounds(bounds);
        }
        this.setState({markers: markers, bounds: bounds});
    };

    //Toggle to 'true' to show InfoWindow and re-renders component
    handleMarkerClick = (marker) => {
        const markers = this.state.markers;
        for(let i=0; i <markers.length; i++) {
            if(markers[i].showInfo){
                markers[i].showInfo = false;
            }
        }
        marker.showInfo = true;
        this.setState(this.state);
    };

    handleMarkerClose = (marker) => {
        marker.showInfo = false;
        this.setState(this.state);
    };

    pickupSiteSelected = (pickupSite, marker, isWaitList) => {
        if(this.props.isValidPickupSiteSelection(pickupSite)) {
            this.props.setPickupSite(pickupSite, isWaitList);
        }
        this.handleMarkerClose(marker);
    };

    renderDeliveryDetails = (pickupSite) => {
        if (pickupSite.deliveryHours && pickupSite.deliveryHours.length > 0) {
            return translate(pickupSite.deliveryDays) + ', ' + pickupSite.deliveryHours;
        }
        return translate(pickupSite.deliveryDays);
    };

    renderInfoWindow = (index, marker) => {
        let pickupSite = marker.pickupSite;
        const deliveryDetails = this.renderDeliveryDetails(pickupSite);
        return (
            <InfoWindow key={index} onCloseClick={this.handleMarkerClose.bind(this, marker)}>
                <div className="pick-up-site-info-window-container">
                    <div className="pick-up-site-info-window-title">{pickupSite.title}</div>
                    <div className="pick-up-site-info-window-address">{pickupSite.shortAddress}</div>
                    <div className="pick-up-site-info-window-day-hour">{deliveryDetails}</div>
                    {
                        marker.type !== 'notSelectable' ?
                            <div className="select-location-map-link"
                                 onClick={this.pickupSiteSelected.bind(this, pickupSite, marker, marker.type === 'waitList')}
                                 id={pickupSite.key}>
                                {translate("Select this location")}
                            </div> : undefined
                    }
                </div>
            </InfoWindow>);
    };

    handleMapCenterChanged = () => {
        if (this.map) {
            const center = this.map.getCenter();
            if (center === this.state.center) {
                return;
            }
            this.setState({center});
            this.props.setMapProps(undefined,center);
        }
    };

    handleMapZoomChanged = () => {
        if (this.map) {
            const zoom = this.map.getZoom();
            if (zoom === this.state.zoom) {
                return;
            }
            this.setState({zoom});
            this.props.setMapProps(zoom);
        }
    };

    handleMapMounted = (map) => {
        if(map && !this.props.zoomLevel) {
            map.fitBounds(this.state.bounds);
            let zoom = map.getZoom();
            this.props.setMapProps(zoom);
        }
        this.map = map;
    };

    handleSearchBoxMounted = (searchBox) => {
        this._searchBox = searchBox;
    };

    handlePlacesChanged = () => {
        const places = this._searchBox.getPlaces();

        // Add a marker for each place returned from search bar
        const markers = places.map(place => ({
            position: place.geometry.location
        }));

        // Set markers; set map center to first search result
        const mapCenter = markers.length > 0 ? markers[0].position : this.state.center;

        this.setState({
            center: mapCenter, zoom: 12
        });
    };

    handleBoundsChanged = () => {
        this.setState({
            bounds: this.map.getBounds(),
            center: this.map.getCenter()
        });
    };

    render() {
        return (<div>
            <JoinPickupSiteFilter clientViewPort={this.props.clientViewPort}
                                  deliveryDayFilter={this.props.deliveryDayFilter}
                                  setDeliveryDayFilter={this.props.setDeliveryDayFilter}
                                  pickupSiteSelectionType={PickupSiteSelectionTypes.MAP}
                                  pickupSites={this.props.pickupSites}/>
            {
                this.props.clientViewPort.isXs ? undefined :
                    <div className="map-instructions">{translate("pickupSiteMapDetails")}</div>
            }
            <PickupSitesMap containerElement={<div className="google-map-container"/>}
                            mapElement={<div style={{height: "100%"}}/>}
                            options={this.props.options}
                            center={this.state.center}
                            markers={this.state.markers}
                            zoom={this.state.zoom}
                            bounds={this.state.bounds}
                            handleMarkerClick={this.handleMarkerClick}
                            handleMarkerClose={this.handleMarkerClose}
                            renderInfoWindow={this.renderInfoWindow}
                            handleMapZoomChanged={this.handleMapZoomChanged}
                            handleMapCenterChanged={this.handleMapCenterChanged}
                            onMapMounted={this.handleMapMounted}
                            onSearchBoxMounted={this.handleSearchBoxMounted}
                            onPlacesChanged={this.handlePlacesChanged}
                            onBoundsChanged={this.handleBoundsChanged}
                            isXs={this.props.clientViewPort.isXs}/>/>

        </div>);
    }
}

export default JoinPickupSiteMap;



// WEBPACK FOOTER //
// ./src/components/join/JoinPickupSiteMap.js